import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Hide Emergent badge
const hideBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) {
    badge.style.display = 'none';
    badge.style.visibility = 'hidden';
  }
};
// Run on load and observe for dynamic injection
hideBadge();
const observer = new MutationObserver(hideBadge);
observer.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
